import React from 'react';
import { FetchPolicy, useQuery } from '@apollo/client';
import { IBosApiDealerInfoData } from 'next-common';
import { queryDealer } from '../../graphql';
import { ERROR_POLICY } from '../constants';
import { useSelector, useDispatch } from 'react-redux';
import { selectDealerById } from '@store/selectors/dealerSelectors';
import { setDealer } from '@store/slices/dealerSlice';

export interface IDealerParams {
  dealerId: string;
  fetchPolicy?: FetchPolicy;
}

export interface IDealerResult {
  dealer: IBosApiDealerInfoData;
  loading: boolean;
}

export const useDealer = (params: IDealerParams): IDealerResult => {
  const dispatch = useDispatch();
  const dealer = useSelector(selectDealerById(params.dealerId));

  // Only fetch if dealer not in store and dealerId exists
  const { data, loading } = useQuery(queryDealer, {
    variables: { dealerId: params.dealerId },
    skip: !params.dealerId || !!dealer,
    errorPolicy: ERROR_POLICY,
    fetchPolicy: params.fetchPolicy || 'cache-first',
  });

  // Store dealer in redux if fetched and not already present
  React.useEffect(() => {
    if (data?.dealer && params.dealerId && !dealer) {
      dispatch(setDealer({ dealerId: params.dealerId, dealer: data.dealer }));
    }
  }, [data, params.dealerId, dealer, dispatch]);

  return { dealer: dealer || data?.dealer, loading: dealer ? false : loading };
};
